import { ReactComponent as CollaborationIcon } from "src/assets/icons/collaboration-icon.svg";
import { ReactComponent as FlipChartIcon } from "src/assets/icons/flip-chart-icon.svg";
import { ReactComponent as BriefcaseIcon } from "src/assets/icons/briefcase-icon.svg";
import { ReactComponent as DashboardIcon } from "src/assets/icons/dashboard-icon.svg";
import { ReactComponent as StarIcon } from "src/assets/icons/star-icon.svg";
import { ReactComponent as ReceiptIcon } from "src/assets/icons/receipt-icon.svg";
import { ReactComponent as ChartIcon } from "src/assets/icons/chart-icon.svg";
import { ReactComponent as NoteIcon } from "src/assets/icons/note-icon.svg";
import { ReactComponent as EmojiIcon } from "src/assets/icons/emoji-icon.svg";
import { IServiceCard } from "./types";

export const SERVICE_CARDS: IServiceCard[] = [
  {
    id: "1",
    icon: CollaborationIcon,
    title: "Бухгалтерське обслуговування",
    description:
      "Бухгалтерія для ФОП, ТОВ, ГО, ОСББ, БФ, релігійних організацій, фермерських господарств тощо.",
    overlayClassName:
      "bg-green-base rounded-2xl rounded-br-none text-white-base",
  },
  {
    id: "2",
    icon: FlipChartIcon,
    title: "Реєстрація бізнесу та організацій",
    description:
      "Реєстрація ФОП, ТОВ, НО, ОСББ, БФ, релігійних організацій, фермерських господарств тощо.",
    className: "bg-white-base rounded-bl-40 lg:rounded-b-40",
    overlayClassName: "bg-green-base text-green-base",
  },
  {
    id: "3",
    icon: BriefcaseIcon,
    title: "Управлінська та казначейська звітність",
    description:
      "Управлінська звітність, робота з казначейством.",
    className: "bg-white-base rounded-r-40 lg:rounded-r-none lg:bg-transparent",
    overlayClassName:
      "bg-green-base text-green-base lg:text-white-base lg:rounded-2xl lg:rounded-bl-none",
  },
  {
    id: "4",
    icon: DashboardIcon,
    title: "Аудит і фінансова звітність",
    iconClassName: "fill-green-light lg:fill-none",
    titleClassName: "break-all",
    description:
      "Аудит документів. Складання, подання та фінансової звітності.",
    className: "bg-green-base rounded-r-2xl lg:bg-white-base lg:rounded-r-40",
    overlayClassName:
      "lg:bg-green-base text-white-base lg:text-green-base rounded-bl-none",
  },
  {
    id: "5",
    icon: StarIcon,
    title: "Юридичний супровід бізнесу",
    description:
      "Повний юридичний супровід бізнесу, складання договорів, перевірка контрагентів, захист інтересів у суді.",
    className: "bg-green-base text-white-base rounded-l-2xl lg:rounded-l-none",
  },
  {
    id: "6",
    icon: ReceiptIcon,
    title: "Бюджетування та грантовий супровід",
    description:
      "Складання бюджетів, грантрайтинг та супровід грантів.",
    className: "bg-white-base rounded-l-40",
    overlayClassName: "bg-green-base text-green-base rounded-bl-none ",
  },
  {
    id: "7",
    icon: ChartIcon,
    title: "Відновлення обліку",
    description:
      "Відновлення бухгалтерського обліку попередніх періодів.",
    className: "bg-white-base rounded-r-40 lg:bg-transparent lg:rounded-r-none",
    overlayClassName:
      "bg-green-base text-green-base lg:rounded-2xl lg:rounded-tr-none lg:text-white-base ",
  },
  {
    id: "8",
    icon: NoteIcon,
    iconClassName: "fill-green-light lg:fill-none",
    title: "Розблокування податкових накладних",
    description:
      "Розблокування податкових накладних.",
    className: "lg:bg-white-base rounded-t-40",
    overlayClassName:
      "bg-green-base text-white-base lg:text-green-base rounded-r-2xl lg:rounded-r-none",
  },
  {
    id: "9",
    icon: EmojiIcon,
    title: "Консультації та супровід перевірок",
    description:
      "Консультації, разова звітність, присутність при перевірках.",
    overlayClassName:
      "relative bg-green-base rounded-tr-none rounded-2xl lg:rounded-tr-2xl lg:rounded-tl-none text-white-base ",
  },

  // placeholder for the last card in mobile view to add a rounded corner (from)
  {
    id: "10",
    icon: EmojiIcon,
    iconClassName: "hidden",
    title: "",
    description: "",
    className: "bg-white-base rounded-tl-40",
    overlayClassName: "lg:hidden bg-green-base text-green-base rounded-b-none ",
  },
  // (to)
];
